import React from 'react';
import Button from '../Button';
import i18n from '../../i18n/translate';

const SeeAllFilterButton = props => {
  return (
    <Button
      {...props}
      className="filter-button selected"
      label={i18n.t('See All Filters')}
      style="pill" />
  );
}

export default SeeAllFilterButton;
